import React from 'react';
import PropTypes from 'prop-types';

import {connect, Controller} from '@stubhub/react-store-provider';

import {DATALAYER_REDUX_NAMESPACE} from './consts';
import MapToDataLayer from './map-to-datalayer';

const defaultReducer = (state, {__reset__, ...otherData}) => otherData;

class TrackingDataLayerController extends Controller {
  constructor({dataKey, action, clearAction, reducer = defaultReducer} = {}) {
    const instance = super({
      namespace: DATALAYER_REDUX_NAMESPACE,
      autoDisconnect: true,
      mapStateToProps(state) {
        const localState = this.getLocalState(state);
        if (localState[dataKey]) {
          return {dataKey, data: localState[dataKey]};
        }

        return {};
      },
    });

    /* istanbul ignore else */
    if (action) {
      this.addReducer(action, (state, action) => {
        const localState = {...this.getLocalState(state)};

        const output = typeof reducer === 'function' && reducer(state, action);

        /* istanbul ignore else */
        if (output) {
          const currentKeyValue = localState[dataKey] || {};
          localState[dataKey] = {...currentKeyValue, ...output};
        }

        return this.setLocalState(state, localState);
      });
    }

    if (clearAction) {
      this.addReducer(clearAction, (state) => {
        const localState = {...this.getLocalState(state)};
        localState[dataKey] = undefined;

        return this.setLocalState(state, localState);
      });
    }

    return instance;
  }
}

function MapToDataLayerWrap({dataKey, data}) {
  if (dataKey && data) {
    return <MapToDataLayer dataKey={dataKey} data={data} />;
  }

  return null; // Unmount the MapToDataLayer to clean from data layer
}

MapToDataLayerWrap.propTypes = {
  data: PropTypes.object,
  dataKey: PropTypes.string.isRequired,
};
class ReduxActionTracker extends React.PureComponent {
  // Simple empty child to be wrapped by `connect` HOC and mounted on react layer
  ConnectedComp = connect(new TrackingDataLayerController(this.props))(MapToDataLayerWrap);

  render() {
    const Comp = this.ConnectedComp;

    return <Comp />;
  }
}

export default ReduxActionTracker;
